// extracted by mini-css-extract-plugin
export default {"base-calendar-day":"BaseCalendarDay_base-calendar-day__H7xVP","baseCalendarDayFull":"BaseCalendarDay_baseCalendarDayFull__hWNmf"};